"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expectedSalaryAskOf = expectedSalaryAskOf;
exports.salaryAgainstBudgetOf = salaryAgainstBudgetOf;
const money_1 = require("./money");
const candidate_browse_1 = require("./candidate-browse");
/**
 * The application's own answer to "expected salary": `form_answers.expectedSalary` holds whole
 * units as typed, with its currency (`candidate-identity.service`); here in minor units (#7).
 */
function expectedSalaryAskOf(formAnswers) {
    if (typeof formAnswers !== 'object' || formAnswers === null || !('expectedSalary' in formAnswers))
        return null;
    return askFromAnswer(formAnswers.expectedSalary);
}
function askFromAnswer(answer) {
    if (typeof answer !== 'object' || answer === null || !('amount' in answer) || !('currency' in answer))
        return null;
    const currency = money_1.currencyCodeSchema.safeParse(answer.currency);
    if (typeof answer.amount !== 'string' || !/^\d{1,12}$/.test(answer.amount) || !currency.success)
        return null;
    return { minor: (0, money_1.toMinorUnits)(Number(answer.amount), currency.data), currency: currency.data };
}
/** `expectedSalaryAnswer` is the stored `form_answers -> 'expectedSalary'` value (as `RankedApplication.expectedSalaryAnswer`). */
function salaryAgainstBudgetOf(expectedSalaryAnswer, budgetMaxMinor, budgetCurrency) {
    const ask = askFromAnswer(expectedSalaryAnswer);
    const minor = ask?.minor ?? null;
    const currency = ask?.currency ?? null;
    return {
        overBudgetPercent: (0, candidate_browse_1.overBudgetPercent)(minor, currency, budgetMaxMinor, budgetCurrency),
        isWithinBudget: (0, candidate_browse_1.expectedSalaryWithinBudget)(minor, currency, budgetMaxMinor, budgetCurrency),
    };
}
//# sourceMappingURL=salary-budget.js.map